import { render, staticRenderFns } from "./scorm2.vue?vue&type=template&id=2449d7d3"
import script from "./scorm2.vue?vue&type=script&lang=js"
export * from "./scorm2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports